module.exports = "/images/vendor/desiigner-svg/svg/ui/arrow-bottom-right.svg?e771c77b38def0a8ffe13c1a7e952863";